import { render } from "./SideBar.vue?vue&type=template&id=726931a8"
import script from "./SideBar.vue?vue&type=script&lang=js"
export * from "./SideBar.vue?vue&type=script&lang=js"

import "./SideBar.vue?vue&type=style&index=0&id=726931a8&lang=css"
script.render = render

export default script